module.exports = __webpack_public_path__ + "static/img/Harvest Forecast.f026e355.webp";